// import React from "react";


// const Delete = () => {


//     return(

//         <div>

//             <h1>
//                 Delete
//             </h1>
//         </div>
//     )
// }
// export default Delete



import React, { useState } from 'react';
import axios from 'axios';
import { Button, Form, Container, Alert, Row, Col, Card, Modal } from 'react-bootstrap';
import './Delete.css'
const Delete = () => {
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [userData, setUserData] = useState(null);
    const [error, setError] = useState(null);
    const [otpSent, setOtpSent] = useState(null);
    const [isOtpVerified, setIsOtpVerified] = useState(false);
    // Function to handle the submission of the email to send OTP
    const handleSendOtp = async () => {
        try {
            const response = await axios.post('https://api.lbnhyderabad.com/login/api/send-otp', { email });
            setOtpSent(response.data.otp);
            setIsOtpSent(true);
            setError(null);
        } catch (err) {
            setError('Failed to send OTP');
        }
    };

    // Function to handle the OTP verification
    const handleVerifyOtp = async () => {
        if (otp !== otpSent) {
            setError('Invalid OTP');
            return;
        }

        try {
            const response = await axios.get(`https://api.lbnhyderabad.com/login/api/user?email=${email}`);
            setUserData(response.data);
            setError(null);
            setIsOtpVerified(true);
        } catch (err) {
            setError('Failed to fetch user data');
        }
    };


    const [showModal, setShowModal] = useState(false);

    const [success, setSuccess] = useState(false);

    // Function to handle modal close
    const handleCloseModal = () => setShowModal(false);

    // Function to handle modal open
    const handleOpenModal = () => setShowModal(true);

    // Function to handle account deletion
    const handleDeleteAccount = async () => {
        try {
            // Make the API call to update the Flag column to 1 (deleted)
            await axios.put(`https://api.lbnhyderabad.com/login/api/delete-account`, { email: userData.email });

            setSuccess(true); // Show success message
            setError(null);   // Clear any previous errors
            setShowModal(false); // Close the modal
            window.location.reload();
        } catch (err) {
            setError('Failed to delete account. Please try again.');
            setSuccess(false); // Clear success message on error
        }
    };

    return (
        // <div style={{ textAlign: 'center', marginTop: '50px' }}>
        //   <h2>OTP Verification</h2>

        //   {!isOtpSent ? (
        //     // Email input form
        //     <div>
        //       <input
        //         type="email"
        //         placeholder="Enter your email"
        //         value={email}
        //         onChange={(e) => setEmail(e.target.value)}
        //         style={{ padding: '8px', margin: '10px' }}
        //       />
        //       <button onClick={handleSendOtp} style={{ padding: '8px 12px' }}>
        //         Send OTP
        //       </button>
        //     </div>
        //   ) : (
        //     // OTP input form
        //     <div>
        //       <input
        //         type="text"
        //         placeholder="Enter OTP"
        //         value={otp}
        //         onChange={(e) => setOtp(e.target.value)}
        //         style={{ padding: '8px', margin: '10px' }}
        //       />
        //       <button onClick={handleVerifyOtp} style={{ padding: '8px 12px' }}>
        //         Verify OTP
        //       </button>
        //     </div>
        //   )}

        //   {error && <div style={{ color: 'red', marginTop: '20px' }}>{error}</div>}

        //   {userData && (
        //     <div style={{ marginTop: '20px' }}>
        //       <h3>User Details</h3>
        //       <p>Name: {userData.name}</p>
        //       <p>Email: {userData.email}</p>
        //       <p>Mobile: {userData.mobile}</p>
        //       <p>Membership No: {userData.membershipNo}</p>
        //       {/* <p>Business Vertical: {userData.businessVerticalData}</p> */}

        //     </div>
        //   )}
        // </div>

        <Container className="mt-5 mb-5">
            <Row className="justify-content-center">
                <Col xs={12} md={6}>
                    <div className="text-center">
                        <h2>OTP Verification</h2>

                        {/* Only show email input if OTP is not sent yet */}
                        {!isOtpSent && !isOtpVerified ? (
                            <div>
                                <Form>
                                    <Form.Group controlId="formEmail">
                                        <Form.Control
                                            type="email"
                                            placeholder="Enter your email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </Form.Group>

                                    <Button variant="primary" onClick={handleSendOtp} block>
                                        Send OTP
                                    </Button>
                                </Form>
                            </div>
                        ) : null}

                        {/* Only show OTP input if OTP is sent but not verified */}
                        {isOtpSent && !isOtpVerified ? (
                            <div>
                                <Form>
                                    <Form.Group controlId="formOtp">
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter OTP"
                                            value={otp}
                                            onChange={(e) => setOtp(e.target.value)}
                                        />
                                    </Form.Group>

                                    <Button variant="success" onClick={handleVerifyOtp} block>
                                        Verify OTP
                                    </Button>
                                </Form>
                            </div>
                        ) : null}

                        {/* Display error message if any */}
                        {error && <Alert variant="danger" className="mt-3">{error}</Alert>}

                        {/* Only show user data after OTP is successfully verified */}
                        {/* {isOtpVerified && userData && (
                    
                            <div className="mt-4">
                                <Card className="user-details-card">
                                    <Card.Body>
                                        <Card.Title>User Details</Card.Title>
                                        <Row>
                                            <Col xs={6}>
                                                <strong>Name:</strong>
                                            </Col>
                                            <Col xs={6}>
                                                {userData.name}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={6}>
                                                <strong>Email:</strong>
                                            </Col>
                                            <Col xs={6}>
                                                {userData.email}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={6}>
                                                <strong>Mobile:</strong>
                                            </Col>
                                            <Col xs={6}>
                                                {userData.mobile}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={6}>
                                                <strong>Membership No:</strong>
                                            </Col>
                                            <Col xs={6}>
                                                {userData.membershipNo}
                                            </Col>
                                        </Row>

                                    </Card.Body>
                                </Card>
                                <h4>Do you want to delete this account </h4>
                                <Button variant="danger" onClick={handleOpenModal} className="mt-4">
                                    Delete Account
                                </Button>
                            </div>
                        )} */}


                        {isOtpVerified && userData && userData.Flag === 0 && (
                            <div className="mt-4">
                                <Card className="user-details-card">
                                    <Card.Body>
                                        <Card.Title>User Details</Card.Title>
                                        <Row>
                                            <Col xs={6}>
                                                <strong>Name:</strong>
                                            </Col>
                                            <Col xs={6}>
                                                {userData.name}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={6}>
                                                <strong>Email:</strong>
                                            </Col>
                                            <Col xs={6}>
                                                {userData.email}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={6}>
                                                <strong>Mobile:</strong>
                                            </Col>
                                            <Col xs={6}>
                                                {userData.mobile}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={6}>
                                                <strong>Membership No:</strong>
                                            </Col>
                                            <Col xs={6}>
                                                {userData.membershipNo}
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>

                                <h4>Do you want to delete this account?</h4>
                                <Button variant="danger" onClick={handleOpenModal} className="mt-4">
                                    Delete Account
                                </Button>
                            </div>
                        )}

                        {/* Show message if Flag === 1 */}
                        {isOtpVerified && userData && userData.Flag === 1 && (
                            <div style={{ color: 'red', marginTop: '20px' }}>
                                <h3>This Account is already deleted.</h3>
                            </div>
                        )}

                    </div>
                    <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm Deletion</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>Are you sure you want to delete this account?</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                Cancel
                            </Button>
                            <Button variant="danger" onClick={handleDeleteAccount}>
                                Delete
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </Col>
            </Row>
        </Container>);
};

export default Delete;


